<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu đặt hàng</h1>
      <div class="btn-group gap-2">
        <b-button  @click="$router.push('/order-form-add')" variant="success"
          data-toggle="tooltip" data-placement="top">
          <i class="bx bx-plus"></i><span>&nbsp;</span>
          Tạo phiếu đặt hàng
        </b-button>
         <b-button v-if="dataUser.permissionCodes?.includes('CNPS_DEVICE_PURCHASE_ORDER_EXPORT')" @click="exportExcel" variant="primary">
          <i class="bx bx-download"></i><span>&nbsp;</span>
          {{ loadingExport ? 'Đang tải...' : ' Tải file' }}
        </b-button>
      </div>
    </div>
    <div class="pt-15 b-t-1-869fb229">
      <div class="card-header">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <DateRangePicker placeholder="Thời gian tạo" class="w-100" :ranges="false" @update="transformDate()"
              v-model="dateRange" :locale-data="localeData">
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em"
                  class="text-center font-size-12">
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input type="text" v-model.trim="search.billNumber" class="form-control f12 hc-37 text-search"
              placeholder="Mã đơn hàng" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.creatorId" :settings="searchAgent" placeholder="Người tạo"></Select2>
          </div>

          <div class="form-group">
            <Select2 v-model="search.agentId" :settings="searchAgent" placeholder="Đơn vị nhận"></Select2>
          </div>
            <div class="form-group">
              <Select2
                placeholder="Đối tác"
                v-model="search.partnerCode"
                :options="partnerCodeMap"
              >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.status" :options="optionStatus"
              :settings="{ placeholder: 'Trạng thái' }"></Select2>
          </div>

          <div class="form-group form-group-action">
            <button @click="submitForm" class="pt-2 mr-2 btn btn-primary hc-37" data-toggle="tooltip"
              data-placement="top" title="Lọc">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button @click="resetFilters" type="button" class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip" data-placement="top" title="Bỏ lọc">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="mb-2 total-label">Tổng: <span class="text-primary">{{ pagination.total | formatNumberVN }}</span></div>
            <b-table :busy.sync="loading" sticky-header hover responsive :items="list" :fields="tableFields"
              :fixed="true" :bordered="true">
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>

              <template #cell(createdTime)="data">
                <p v-if="data.item.createdTimeStr">
                  {{ data.item.createdTimeStr}}
                </p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="transformDataColor(data.item.status, optionStatus)">
                  {{ data.item.status | transformData(optionStatus) }}
                </span>
              </template>

              <template #cell(totalQuantity)="data">
                {{ calculateTotalQuantity(data.item.orderDetail) }}
              </template>

              <template #cell(action)="{ item }">
                <button class="btn btn-info btn-sm mr-2" @click="viewDetails(item.id)">
                  Chi tiết
                </button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom px-4">
        <b-pagination v-model="search.page" :total-rows="pagination.total" :per-page="search.limit"
          class="mr-2 "></b-pagination>
      </div>
    </div>
    <ModalExportNoti ref="uploadNotif" />

  </div>
</template>

<script>
import { DeviceService } from '@/services/device.service'
import moment from 'moment'
import Config from '@/thirdParty/config'
import { CommonService } from '@/services/common.service'
import ModalExportNoti from '@/components/ModalExportNoti.vue'

const tableFields = [
  { key: 'index', label: 'STT' },
  { key: 'orderCode', label: 'Mã phiếu' },
  { key: 'createdTimeStr', label: 'Ngày tạo' },
  { key: 'userCreator.name', label: 'Người tạo' },
  { key: 'agentName', label: 'Đơn vị nhận' },
  { key: 'totalQuantity', label: 'Tổng SL' },
  { key: 'status', label: 'Trạng thái' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]

export default {
  name: 'DeviceList',
  components: {
    ModalExportNoti
  },
  data () {
    return {
      dataUser: JSON.parse(localStorage.getItem('userData')),
      loadingExport: false,
      partnerCodeMap: [],
      loading: false,
      showLoading: false,
      tableFields,
      optionCreators: [],
      optionInventory: [],
      optionStatus: [
        { id: '0', text: 'Tất cả', variant: '' },
        ...Config.satusOderForm
      ],
      list: [],
      search: {
        page: 1,
        limit: 20
      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      searchAgent: {
        ajax: {
          delay: 500,
          transport: (params, success, failure) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            const keySearch = txtSearch ?? ''
            if (this.tLoadOwner) {
              clearTimeout(this.tLoadOwner)
            }
            this.tLoadOwner = setTimeout(() => {
              CommonService.getListAgentBank({
                keyword: keySearch
              }) // AI
                .then((res) => {
                  success({
                    results:
                      res.data?.map((item) => {
                        return {
                          id: item?.agentId,
                          text: item.name || ''
                        }
                      }) || []
                  })
                })
                .catch(failure)
            }, 500)
          }
        }
      },
      localeData: Config.localeData,
      pagination: {
        total: 0
      }
    }
  },

  filters: {
    transformData (data, dataConfig) {
      const dataReturn = dataConfig.filter((e) => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].text
    }
  },

  mounted () {
    this.fetchData()
    this.fetchĐataPartner()
  },

  watch: {
    'search.limit': function () {
      this.fetchData()
    },
    'search.page': function () {
      this.fetchData()
    }
  },

  methods: {
    openModalLoadFile (id) {
      this.$refs.uploadNotif.triggerNotification(id)
    },
    async exportExcel () {
      try {
        this.loadingExport = true

        for (const key in this.search) {
          if (this.search[key] === '' || this.search[key] === null || this.search[key] === '0') delete this.search[key]
        }

        const body = {
          object: this.search,
          type: 'CNPS_DEVICE_PURCHASE_ORDER'
        }

        const data = await CommonService.receiveFile(body)

        if (data.success) {
          await this.openModalLoadFile(data.data.id)
        }
      } catch (error) {
        this.showFailMx(`Lỗi: ${error.message}`)
      } finally {
        this.loadingExport = false
      }
    },
    async fetchĐataPartner () {
      try {
        const data = await CommonService.getListAgentPartner({ page: 1, limit: 1000 })
        if (data.code === 1000) {
          this.partnerCodeMap = data.data.map((item) => {
            return {
              id: item?.code,
              text: item.name || ''
            }
          }) || []
          this.partnerCodeMap.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      }
    },
    calculateTotalQuantity (orderDetail) {
      if (!orderDetail || !Array.isArray(orderDetail)) return 0
      return orderDetail.reduce((sum, item) => sum + (item.quantity || 0), 0)
    },

    transformDataColor (data, dataConfig) {
      const dataReturn = dataConfig.filter((e) => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].bgColor
    },

    transformDate () {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate)
          .endOf('day')
          .valueOf()
      } else {
        delete this.search.dateFrom
        delete this.search.dateTo
      }
    },

    async submitForm (event) {
      event.preventDefault()
      this.search.page = 1
      await this.fetchData()
    },

    async resetFilters () {
      this.search = {
        page: 1,
        limit: 20,
        projectionList: []
      }
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      await this.fetchData()
    },

    viewDetails (id) {
      this.$router.push(`/order-form-detail/${id}`)
    },

    formatDateTime (dateString) {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()

      return `${hours}:${minutes}, ${day}/${month}/${year}`
    },

    getIndex (index) {
      return (this.search.page - 1) * this.search.limit + index + 1
    },

    filterObject (obj) {
      const result = {}

      let hasInvalidValue = false

      for (const [key, value] of Object.entries(obj)) {
        if (value === null || value === '0' || value === 'all' || value === '') {
          hasInvalidValue = true
          continue
        }
        result[key] = value
      }

      return hasInvalidValue ? result : obj
    },

    async fetchData () {
      if (!this.loading) this.showLoading = true
      try {
        this.loading = true
        const payload = this.filterObject(this.search)
        // Chuẩn bị dữ liệu request theo interface mới
        const requestParams = {
          ...payload
        }

        // Gọi API với tham số mới
        const response = await DeviceService.getListOrderForm(requestParams)

        if (response.code === 1000) {
          this.list = response.data || []
          this.pagination.total = response?.totalPage?.total || 0
        } else {
          this.list = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.list = []
        this.pagination.total = 0
      } finally {
        this.loading = false
        this.showLoading = false
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.box-search {
  display: flex;
  flex-wrap: wrap;
}

.form-group {
  margin-bottom: 10px;
  min-width: 200px;
}

.form-group-action {
  display: flex;
  align-items: flex-end;
}

.pagination-bottom {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
</style>
